import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

//Account Redux states
import { TOGGLE_AREA_ENTRY_STRATEGY } from './actionTypes';
import { toggleAreaEntryStrategyFailure, toggleAreaEntryStrategySuccess } from './actions';

// Include call API
import { getEntryStrategiesAPI } from '../../../api/entryestrategies';

const entryStrategiesAPI = getEntryStrategiesAPI();

// Is user register successfull then direct plot user in redux.
function* toggleAreaEntryStrategy({ payload: { token, id, active, history } }) {
  try {
    const response = yield call(entryStrategiesAPI.toggleAreaEntryStrategy, { token, id, active });
    yield put(toggleAreaEntryStrategySuccess(response));
    history.go();
  } catch (error) {
    yield put(toggleAreaEntryStrategyFailure(error));
  }
}

export function* watchToggleAreaEntryStrategy() {
  yield takeEvery(TOGGLE_AREA_ENTRY_STRATEGY, toggleAreaEntryStrategy);
}

function* toggleAreaEntryStrategySaga() {
  yield all([fork(watchToggleAreaEntryStrategy)]);
}

export default toggleAreaEntryStrategySaga;
